import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLoaderData } from "react-router-dom";
import styles from './MiraiCareer.css';

const MiraiNewsDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);

  const serviceData = useLoaderData();
  const [newsData, setNewsData] = useState([]); // State for storing news data
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [totalPages, setTotalPages] = useState(1); // Total pages from backend
  const [loading, setLoading] = useState(false); // Loading state
  

  const fetchNews = async (page) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://mirai-server.vercel.app/news-home-data?page=${page}`
      );
      const { data, pages } = response.data; // Destructure response data

      setNewsData(data); // Update news data state
      setTotalPages(pages); // Update total pages
      setLoading(false);
    } catch (error) {
      console.error("Error fetching news data:", error);
      setLoading(false);
    }
  };

  // Fetch data when the component mounts or currentPage changes
  useEffect(() => {
    fetchNews(currentPage);
  }, [currentPage]);

    const serviceContent = serviceData?.content;
  
    useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top when component mounts
  
      // Apply Tailwind CSS classes to strong elements
      const strongElements = document.querySelectorAll('.styled-content strong');
      strongElements.forEach((el) => {
        // Check if the element has font-size: 18px
        if (window.getComputedStyle(el).fontSize === '18px') {
          // Applying Tailwind classes dynamically
          el.classList.add('textLine', 'text-3xl');
        }
      });
    }, []);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div>
      <div className="text-justify lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
        <div className="text-justify w-full  max-w-screen-2xl mx-auto p-4 ">
          <div className="text-justify flex lg:flex-row sm:flex-col gap-5">
            <div className="text-justify w-full">
              <h1 className="text-justify lg:text-3xl sm:text-xl font-semibold font-jost customBlue">
                {serviceData.title}
              </h1>
              {
                serviceData.singleImage ?
                <img className="text-justify my-6 object-cover" src={serviceData.singleImage} alt=""></img>
                : ""
              }
              <p className="text-justify mt-5">{serviceData.description}</p>

              {/* Render the sets */}
             <div>
                         <div
                           className={`font-jost mt-10 styled-content ${styles.table}`}
                           dangerouslySetInnerHTML={{ __html: serviceContent }}
                         />
                       </div>
            </div>
            <div>
              <div className="text-justify lg:w-96 md:w-full lg:p-5 sm:p-2 border border-blue-50 rounded shadow-md">
                <h1 className="text-justify lg:text-2xl sm:text-xl font-semibold font-jost text-blue-500 lg:p-5 sm:p-2">
                  Top Coulmns
                </h1>
                <div className="text-justify w-full ">
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    newsData.map((item, index) => (
                      <Link
                        className="text-justify "
                        to={`/news-details/${item._id}`}
                        key={index}
                      >
                        <div className="text-justify flex flex-col mt-5 gap-1 justify-between border-b  hover:shadow-md lg:p-5 sm:p-2 hover:border-blue-500 duration-300 ease-in-out">
                          <h1 className="text-justify lg:text-xl sm:text-md font-jost text-blue-500">
                            {item.title}
                          </h1>
                          <span className="text-justify lg:text-xl sm:text-sm">
                            Posted Date:{" "}
                            {new Date(item.createdAt).toDateString()}
                          </span>
                        </div>
                      </Link>
                    ))
                  )}
                </div>

                {/* Pagination Controls */}
                <div className="text-justify flex justify-start mt-4">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                    className="text-justify px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <span className="text-justify px-4 py-2  font-jost text-sm bg-blue-50">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    className="text-justify px-4 py-2  bg-blue-500 font-jost text-sm text-white rounded disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiraiNewsDetails;
